// Dashboard — KPIs agregados, agenda de hoje, novos pacientes, alertas.
// Cutover: overview() fala com /clinica/dashboard. Adapter no front faz
// snake→camel dos KPIs e deriva apresentação (initials/avatarClass).
import AXIOS from "@/services/axios";
import { initialsOf, avatarClassFor } from "./helpers";

function adaptKpis(k = {}) {
  return {
    consultasMes: k.consultas_mes,
    realizadas: k.realizadas,
    pendentes: k.pendentes,
    canceladas: k.canceladas,
    pacientesAtivos: k.pacientes_ativos,
    pacientesCadastrados: k.pacientes_cadastrados,
    novosPacientes: k.novos_pacientes,
    receitaMesCents: k.receita_mes_cents,
    repassesPendentesCents: k.repasses_pendentes_cents,
    semRetorno: k.sem_retorno
  };
}

function adaptTodayRow(t, i) {
  const patient = t.patient || {};
  return {
    id: t.id,
    time: t.time,
    patientId: patient.id,
    patientName: patient.name,
    initials: initialsOf(patient.name),
    avatarClass: avatarClassFor(i),
    doctorName: t.doctor_name,
    status: t.status
  };
}

function adaptNewPatient(p, i) {
  return {
    id: p.id,
    name: p.name,
    initials: initialsOf(p.name),
    avatarClass: avatarClassFor(i),
    statusLabel: "Novo",
    specialty: p.specialty
  };
}

export class ClinicDashboard {
  /** Visão geral; `month` (AAAA-MM) muda KPIs, receita e evolução. */
  static overview({ month } = {}) {
    const path = month
      ? `clinica/dashboard?month=${month}`
      : "clinica/dashboard";
    return AXIOS.get(path).then(({ data }) => ({
      data: {
        kpis: adaptKpis(data.kpis),
        evolution: data.evolution || [],
        today: (data.today || []).map(adaptTodayRow),
        newPatients: (data.new_patients || []).map(adaptNewPatient),
        pendingConfirmations: data.pending_confirmations,
        pendingReschedules: data.pending_reschedules
      }
    }));
  }
}

export default ClinicDashboard;
